module.exports = __webpack_public_path__ + "static/img/banner.36539e26.png";